export default __webpack_public_path__ + "static/section2-gardening-8ac4c620061fc6540226ab459abb92d3.webp";